import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// The static prerender block (SEO text for crawlers) is not React markup, so we
// render from scratch instead of hydrating (avoids a failed hydration pass).
const rootElement = document.getElementById("root");
ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
